import React, { useCallback, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { LoadingModalCtrl } from '@webapp/controllers/loader-modal';
import { CallHistoryMethodAction, push } from 'connected-react-router';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { logout } from '@webapp/sdk/auth';

interface AdminSignInProps {
  push: (path: string) => CallHistoryMethodAction;
  challenge?: string;
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  push: (path: string) => dispatch(push(path)),
});

const AdminSignIn: React.FC<AdminSignInProps> = ({ match, push }: any) => {
  const { challenge } = match?.params;

  const adminSignin = useCallback(
    async (challenge: string) => {
      try {
        await logout();
        const [email, code] = challenge.split(',');
        const user = await Auth.signIn(email);
        await Auth.sendCustomChallengeAnswer(user, code);
        await Auth.currentSession();
        push('/dashboard');
      } catch (e) {
        if (e?.code === 'InvalidParameterException') {
          push('/dashboard');
        } else {
          push('/login');
        }
      }
    },
    [push]
  );

  useEffect(() => {
    adminSignin(challenge);
  }, [challenge, adminSignin]);

  return <LoadingModalCtrl loading={true} />;
};

export default connect(null, mapDispatchToProps)(AdminSignIn);
